export const path = "https://api.wised.in/api/v1/";

